export default [
  {
    name: 'report',
    permissionKey: 'report_management',
    label: 'labels.reportManagement',
    children: [
      {
        name: 'general',
        label: 'labels.reportGeneral',
        permissionKey: 'report_general'
      }
    ]
  }
]
